import Seo from "../components/generic/Seo";
import ProductsGrid from "../components/product/ProductsGrid";

const objSeo = {
  title: "Springevening Private Limited -Soochi ERP and Happy Nenapu flip book",
  keywords:
    "startup, Software company, Soochi ERP, HappyNenapu, Flipbook, Brand reflection,Maximizing brand reach,SEO optimization,Empowering developers, Training, Internship, Bagalkot, BEC, sedamkar, North Karnataka",
  pathSlug: " ",
  description:
    "Smart Products to Digitize Your Business Empowering small businesses with Soochi ERP and HappyNenapu Flipbook tools.",
};

const Products = () => {
  return (
    <>
      <Seo data={objSeo} />
      <ProductsGrid />
    </>
  );
};

export default Products;
